import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/support-teams",
    name: "SupportTeams",
    component: () =>
      import(/* webpackChunkName: "supportteams" */ "../views/SupportTeams.vue")
  },
  {
    path: "/development-teams",
    name: "DevelopmentTeams",
    component: () =>
      import(
        /* webpackChunkName: "developmentteams" */ "../views/DevelopmentTeams.vue"
      )
  },
  {
    path: "/tools",
    name: "Tools",
    component: () =>
      import(/* webpackChunkName: "tools" */ "../views/Tools.vue")
  },
  {
    path: "/logistics",
    name: "Logistics",
    component: () =>
      import(/* webpackChunkName: "logistics" */ "../views/Logistics.vue")
  },
  {
    path: "/services",
    name: "Services",
    component: () =>
      import(/* webpackChunkName: "services" */ "../views/Services.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
